<template>
  <div>
    <b-form-group label="Show as:">
      <b-form-radio-group v-model="showAsModal" :options="[{ text: 'Modal', value: true }, { text: 'Inline', value: false }]" />
    </b-form-group>

    <b-button v-if="showAsModal" @click="showModal = true" variant="success">
      Launch Form from JSON
    </b-button>

    <common-modal
      v-if="showAsModal && formConfig.fields"
      :show.sync="showModal"
      :title="formConfig.formTitle"
      :fields="formConfig.fields"
      :initial-data="formData"
      @submit="handleSubmit"
    />

    <dynamic-form
      v-if="!showAsModal && formConfig.fields"
      :fields="formConfig.fields"
      :initial-data="formConfig.initialData"
      :title="formConfig.formTitle"
      @submit="handleSubmit"
    />
  </div>
</template>

<script>
import CommonModal from "./commonModal.vue";
import DynamicForm from "./DynamicForm.vue";
import formConfigJson from "../../assets/form-config.json";
import {
  required,
  email,
  minLength,
  maxLength,
  minValue,
  maxValue,
} from "vuelidate/lib/validators";

const validationsMap = {
  required,
  email,
  minLength: (val) => minLength(val),
  maxLength: (val) => maxLength(val),
  minValue: (val) => minValue(val),
  maxValue: (val) => maxValue(val),
  checked: (val) => val === true,
};

export default {
  name: "JsonFormLoader",
  components: {
    CommonModal,
    DynamicForm,
  },
  data() {
    return {
      showModal: false,
      showAsModal: true, // true = modal, false = inline
      formConfig: {},
      formData: {},
    };
  },
  created() {
    this.loadFormConfig();
  },
  methods: {
    loadFormConfig() {
      const config = JSON.parse(JSON.stringify(formConfigJson));

      config.fields.forEach((field) => {
        if (field.validations) {
          const fieldValidations = {};
          for (const key in field.validations) {
            if (validationsMap[key]) {
              const ruleValue = field.validations[key];
              if (typeof ruleValue === 'boolean' && ruleValue) {
                fieldValidations[key] = validationsMap[key];
              } else if (typeof ruleValue !== 'boolean') {
                fieldValidations[key] = validationsMap[key](ruleValue);
              }
            }
          }
          field.validations = fieldValidations;
        }
      });

      this.formConfig = config;
      this.formData = Object.assign({}, config.initialData);
    },
    handleSubmit(formData) {
      console.log("Form submitted from JSON config:", formData);
      // Handle the form submission, e.g., send to an API
      this.showModal = false;
    },
  },
};
</script>


// WEBPACK FOOTER //
// JsonFormLoader.vue?1ca0f031